import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/layouts/admin-layout/admin-layout.component';
import { WelcomeLayoutComponent } from './shared/layouts/welcome-layout/welcome-layout.component';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { PERMISSIONS_ENUM } from './core/enum/permission.enum';
import { RssConfigComponent } from './features/rss-config/rss-config.component';

const routes: Routes = [
  {
    path: 'welcome',
    component: WelcomeLayoutComponent,
    pathMatch: 'full',
  },
  {
    path: 'refund-hub',
    loadChildren: () =>
      import('./features/refund-hub/refund-hub.module').then(
        (m) => m.RefundHubModule,
      ),
  },
  {
    path: 'commission-fee',
    loadChildren: () =>
      import('./features/commission-fee/commission-fee.module').then(
        (m) => m.CommissionFeeModule,
      ),
  },
  {
    path: 'homeconnect-category',
    loadChildren: () =>
      import(
        './features/homeconnect-category/homeconnect-category.module'
      ).then((m) => m.HomeconnectCategoryModule),
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: 'promotion-program',
        loadChildren: () =>
          import('./features/promotion-program/promotion-program.module').then(
            (m) => m.PromotionProgramModule,
          ),
        data: {
          permissions: {
            only: [PERMISSIONS_ENUM.SHOP_ADMIN_PROMOTION_ACCESS],
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },
      {
        path: 'voucher-shop',
        loadChildren: () =>
          import('./features/voucher-shop/voucher-shop.module').then(
            (m) => m.VoucherShopModule,
          ),
        data: {
          permissions: {
            only: [PERMISSIONS_ENUM.SHOP_VOUCHER_MANAGEMENT_ACCESS],
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },
      {
        path: 'voucher-v2',
        loadChildren: () =>
          import('./features/voucher-v2/voucher-v2.module').then(
            (m) => m.VoucherV2Module,
          ),
      },
      {
        path: 'order',
        loadChildren: () =>
          import('./features/order/order.module').then((m) => m.OrderModule),
        data: {
          permissions: {
            only: [
              PERMISSIONS_ENUM.SHOP_ORDER_MANAGEMENT_ACCESS,
              PERMISSIONS_ENUM.SHOP_ORDER_MANAGEMENT_VIEW,
            ],
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
        data: {
          permissions: {
            only: PERMISSIONS_ENUM.SHOP_ADMIN_DASHBOARD_ACCESS,
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },
      {
        path: 'shop-management',
        loadChildren: () =>
          import('./features/shop-management/shop-management.module').then(
            (m) => m.ShopManagementModule,
          ),
        data: {
          permissions: {
            only: [PERMISSIONS_ENUM.SHOP_MANAGEMENT_ACCESS],
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },
      {
        path: 'refund-management',
        loadChildren: () =>
          import('./features/refund-management/refund-management.module').then(
            (m) => m.RefundManagementModule,
          ),
        data: {
          permissions: {
            only: [PERMISSIONS_ENUM.SHOP_REFUND_MANAGEMENT_ACCESS],
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },
      {
        path: 'product-management',
        loadChildren: () =>
          import(
            './features/product-management/product-management.module'
          ).then((m) => m.ProductManagementModule),
        data: {
          permissions: {
            only: [PERMISSIONS_ENUM.SHOP_PRODUCT_MANAGEMENT_ACCESS],
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },
      {
        path: 'pre-order-product-management',
        loadChildren: () =>
          import(
            './features/pre-order-product-management/pre-order-product-management.module'
          ).then((m) => m.PreOrderProductManagementModule),
      },
      {
        path: 'banner-management',
        loadChildren: () =>
          import('./features/banner-management/banner-management.module').then(
            (m) => m.BannerManagementModule,
          ),
        data: {
          permissions: {
            only: [
              PERMISSIONS_ENUM.BANNER_SHOP_ACCESS,
              PERMISSIONS_ENUM.BANNER_SHOP_VIEW,
            ],
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },
      {
        path: 'rss-config',
        component: RssConfigComponent
      },
      {
        path: 'faq',
        loadChildren: () =>
          import('./features/faq/faq.module').then((m) => m.FaqModule),
        data: {
          permissions: {
            only: [
              PERMISSIONS_ENUM.CHAT_FAQ_ACCESS,
              PERMISSIONS_ENUM.CHAT_FAQ_VIEW,
            ],
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },

      {
        path: 'soctrip-chat',
        loadChildren: () =>
          import('./features/soctrip-chat/soctrip-chat.module').then(
            (m) => m.SoctripChatModule,
          ),
        data: {
          permissions: {
            only: [
              PERMISSIONS_ENUM.CHAT_SUPPORT_ACCESS,
              PERMISSIONS_ENUM.CHAT_SUPPORT_VIEW_CHAT,
            ],
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },
      // {
      //   path: 'supplier-management',
      //   loadChildren: () =>
      //     import(
      //       './features/supplier-management/supplier-management.module'
      //     ).then((m) => m.SupplierManagementModule),
      //   data: {
      //     permissions: {
      //       only: [PERMISSIONS_ENUM.SHOP_SUPPLIER_MANAGEMENT_ACCESS],
      //       redirectTo: '/',
      //     },
      //   },
      //   canActivate: [ngxPermissionsGuard],
      // },
      // {
      //   path: 'connect-sellers-management',
      //   loadChildren: () =>
      //     import(
      //       './features/connect-sellers-management/connect-sellers-management.module'
      //     ).then((m) => m.ConnectSellersManagementModule),
      //   data: {
      //     permissions: {
      //       only: PERMISSIONS_ENUM.SHOP_CONNECT_SELLER_MANAGEMENT_ACCESS,
      //       redirectTo: '/',
      //     },
      //   },
      //   canActivate: [ngxPermissionsGuard],
      // },
      {
        path: 'promo-section',
        loadChildren: () =>
          import('./features/promo-section/promotion-section.module').then(
            (m) => m.PromoSectionModule,
          ),
        data: {
          permissions: {
            only: [PERMISSIONS_ENUM.SHOP_PROMOTE_SECTION_ACCESS],
            redirectTo: '/',
          },
        },
        canActivate: [ngxPermissionsGuard],
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/home-connect/home-connect.module').then(
            (m) => m.HomeConnectModule,
          ),
      },
      {
        path: 'global-selling',
        loadChildren: () =>
          import('./features/global-selling/global-selling.module').then(
            (m) => m.GlobalSellingModule,
          ),
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },

  // {
  //   path: 'refund-hub/refund-info',
  //   loadChildren: () =>
  //     import('./features/refund-hub/refund-hub.module').then(
  //       (m) => m.RefundHubModule,
  //     ),
  // },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
